import Vue from 'vue';
import VueI18n from 'vue-i18n';
import region from '@/../region.json';
// import deDefault from './locales/de.json';
// import seDefault from './locales/sv.json';

Vue.use(VueI18n);

const { supportedLanguages, defaultLang } = region;

const cachedTranslations = [defaultLang];
const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || defaultLang,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || defaultLang,
  messages: null,
});

async function loadLanguage(lang) {
  return import(
    /* webpackChunkName: "lang-[request]" */ `./locales/${lang}.json`
  ).then(({ default: message }) => message);
}

// The translations must be loaded async "before" the app is mounted.
// Once this resolves the App will mount
export async function initTranslations(lang) {
  switch (lang) {
    case supportedLanguages[lang]: {
      // if the translation has already been loaded then just return the translation.
      if (cachedTranslations.includes(lang)) {
        const translations = await loadLanguage(lang);
        i18n.setLocaleMessage(lang, translations);
        i18n.locale = lang;
        return Promise.resolve(i18n);
      }
      // otherwise we fetch the supported language's translations
      return loadLanguage(lang).then(translations => {
        i18n.setLocaleMessage(lang, translations);
        i18n.locale = lang;
        cachedTranslations.push(lang);
        return Promise.resolve(i18n);
      });
    }
    default:
      return Promise.resolve(i18n);
  }
}

export default i18n;
